/**
 * src/components/common/AvisoNovaVersao.js
 *
 * Avisa que há uma versão nova publicada e oferece recarregar.
 *
 * O sistema registra um service worker, que serve a casca do app a partir do
 * cache. Depois de um deploy, quem já tinha o site aberto continua vendo a
 * versão antiga até fechar tudo — foi o que aconteceu em 28/08, e só apareceu
 * a tela nova depois de Ctrl+Shift+R. Não dá para depender de cada articulador
 * conhecer o atalho.
 *
 * Toda a mecânica já existia e ninguém a tinha ligado: `register()` aceita
 * `onUpdate`, e o service worker já escuta a mensagem `SKIP_WAITING`. O que
 * faltava era alguém contar à pessoa.
 *
 * O aviso NÃO recarrega sozinho. Recarregar por conta própria descartaria o que
 * estiver sendo digitado na justificativa — quem decide a hora é quem está
 * trabalhando.
 */

import React, { useEffect, useState } from 'react';
import { FaArrowRotateRight } from 'react-icons/fa6';
import './AvisoNovaVersao.css';

export default function AvisoNovaVersao() {
  const [registro, setRegistro] = useState(null);

  useEffect(() => {
    const aoAtualizar = (event) => setRegistro(event.detail || null);
    window.addEventListener('mago:nova-versao', aoAtualizar);
    return () => window.removeEventListener('mago:nova-versao', aoAtualizar);
  }, []);

  if (!registro) return null;

  const recarregar = () => {
    // Pede ao service worker em espera que assuma; quando ele assume, o
    // `controllerchange` recarrega a página já com os arquivos novos.
    const esperando = registro.waiting;
    if (!esperando) {
      window.location.reload();
      return;
    }
    // `navigator.serviceWorker` não existe em contexto inseguro nem em
    // navegador sem suporte. Sem esta guarda, clicar em "Recarregar" quebrava
    // ali mesmo — justamente onde a pessoa está tentando sair de uma versão
    // velha.
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener(
        'controllerchange',
        () => window.location.reload(),
        { once: true }
      );
    }
    esperando.postMessage({ type: 'SKIP_WAITING' });
  };

  return (
    <div className="aviso-nova-versao" role="status" aria-live="polite">
      <span className="aviso-nova-versao-txt">
        <b>Há uma versão nova do Mago.</b>{' '}
        Recarregue quando puder — o que estiver escrito agora não se perde ao salvar antes.
      </span>
      <button type="button" className="aviso-nova-versao-btn" onClick={recarregar}>
        <FaArrowRotateRight aria-hidden="true" />
        <span>Recarregar</span>
      </button>
      <button
        type="button"
        className="aviso-nova-versao-depois"
        onClick={() => setRegistro(null)}
        title="Dispensar o aviso; ele volta no próximo carregamento"
      >
        Depois
      </button>
    </div>
  );
}
